// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"WZ-z","subtitle":"XZ-z","wrapper":"YZ-z","leftArrow":"ZZ-z","rightArrow":"_Z-z"};